import { Controller, RegisterOptions } from 'react-hook-form';
import { InputProps } from 'semantic-ui-react';

import { InputWithIcon } from 'pkg/components/InputWithIconAndValidation/InputWithIcon';
import { useFormError } from 'pkg/formHooks/useFormError';

import { FormValidationMessage } from '../FormValidationMessage';

interface InputWithIconAndValidationProps extends Omit<InputProps, 'children'> {
  inputIcon: JSX.Element;
  rules?: RegisterOptions;
}

export const InputWithIconAndValidation = ({
  name,
  rules,
  inputIcon,
  ...restProps
}: InputWithIconAndValidationProps): JSX.Element => {
  const error = useFormError(name);

  return (
    <>
      <Controller
        rules={rules}
        name={name}
        render={({ ref, value, ...props }) => (
          <InputWithIcon {...props} error={Boolean(error)} value={value} {...restProps} inputIcon={inputIcon} />
        )}
      />
      <FormValidationMessage aria-live="polite">{error?.message}</FormValidationMessage>
    </>
  );
};
